import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    favoriteItems: [],
}


const favoriteSlice = createSlice({
    name: "favorite",
    initialState,
    reducers: {
        addToFavorite(state, action) {
            const tempProduct = {...action.payload}
            state.favoriteItems.push(tempProduct)

            localStorage.setItem("favoriteItems", JSON.stringify(state.favoriteItems))
        },
        removeFromFavorite(state, action) {
            console.log("action payload", action.payload._id)
            const nextFavoriteItems = state.favoriteItems.filter(
                favoriteItem => favoriteItem._id !== action.payload._id
            )
            state.favoriteItems = nextFavoriteItems
            localStorage.setItem("favoriteItems", JSON.stringify(state.favoriteItems))
        },
        getTotalsFavorite(state, action) {
            let {total, quantity} = (state.favoriteItems).reduce(
                (favoriteTotal, favoriteItem) => {
                    //calculate total for each item
                    const { price  } = favoriteItem;
                    const itemTotal = price

                    favoriteTotal.total+=itemTotal

                    return favoriteTotal
                }, 
                {
                    total: 0,
                    quantity: state.favoriteItems.length,
                }
            )
            
            state.favoriteTotalQuantity = quantity
            state.favoriteTotalAmount = total
       },
    }
})


export const { addToFavorite, removeFromFavorite, getTotalsFavorite } = favoriteSlice.actions;

export default favoriteSlice.reducer